import styled from 'styled-components';
import {Space} from 'antd';
import {bordersStyles} from '../../../../utils/styles';

const StyledUpcomingSpending = styled(Space)`
  width: 100%;
`;

const StyledUpcomingSpendingItem = styled(Space)`
  width: 100%;

  .date {
    color: ${props => props.theme.colors.neutral_7};
    font-size: 13px;
    font-weight: 400;
    line-height: 22px;
  }
`;

const StyledUpcomingSpendingSpendItem = styled.div`
  ${bordersStyles.default};

  padding: 6px 8px;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .price {
    margin-left: 4px;
    text-wrap: nowrap;
  }

  .ant-space-item {
    word-break: break-word;
  }
`;

export {
  StyledUpcomingSpending,
  StyledUpcomingSpendingItem,
  StyledUpcomingSpendingSpendItem
}
